type BlogUrlItem = {
  blogContentId: string;
};

export function buildBlogPath(blog: BlogUrlItem) {
  return `/blogs/${encodeURIComponent(blog.blogContentId)}`;
}
